const FormResources = {

    form_data:{
        associate_id:       '',
        description:        '',
        date:               '',
        daily_assignment_id:'',
        shift1:             false,
        shift2:             false,
        shift3:             false,
        is_worksheets:      true,
        discharge1:         '',
        discharge2:         '',
        discharge3:         '',
        discharge4:         '',
        discharge5:         '',
        discharge6:         '',
        discharge7:         '',
        discharge8:         '',
        discharge9:         '',
        discharge10:        '',
        discharge11:        '',
        discharge12:        '',
        discharge13:        '',
        discharge14:        '',
        discharge15:        '',
        discharge16:        '',
        discharge17:        '',
        discharge18:        '',
        discharge19:        '',
        discharge20:        '',
        discharge21:        '',
        discharge22:        '',
        discharge_worksheets: [
            {
                minutes:    '',
                description:''
            }
        ],
        associate_signature: '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Vacant bed date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4 ',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Day:',
            model_name: 'shift1',
            ref:        'shift1_input',
            ref_alt:    'shift1_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4 ',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Evening:',
            model_name: 'shift2',
            ref:        'shift2_input',
            ref_alt:    'shift2_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4 ',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Night:',
            model_name: 'shift3',
            ref:        'shift3_input',
            ref_alt:    'shift3_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'number-plus',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Enter completed discharges:',
            model_name: '',
            ref:        '',
            ref_alt:    '',
            required:   null,
            childs:     [
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '1',
                    model_name: 'discharge1',
                    ref:        'discharge1_input',
                    ref_alt:    'discharge1_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '2',
                    model_name: 'discharge2',
                    ref:        'discharge2_input',
                    ref_alt:    'discharge2_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '3',
                    model_name: 'discharge3',
                    ref:        'discharge3_input',
                    ref_alt:    'discharge3_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '4',
                    model_name: 'discharge4',
                    ref:        'discharge4_input',
                    ref_alt:    'discharge4_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '5',
                    model_name: 'discharge5',
                    ref:        'discharge5_input',
                    ref_alt:    'discharge5_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '6',
                    model_name: 'discharge6',
                    ref:        'discharge6_input',
                    ref_alt:    'discharge6_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '7',
                    model_name: 'discharge7',
                    ref:        'discharge7_input',
                    ref_alt:    'discharge7_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '8',
                    model_name: 'discharge8',
                    ref:        'discharge8_input',
                    ref_alt:    'discharge8_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '9',
                    model_name: 'discharge9',
                    ref:        'discharge9_input',
                    ref_alt:    'discharge9_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '10',
                    model_name: 'discharge10',
                    ref:        'discharge10_input',
                    ref_alt:    'discharge10_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '11',
                    model_name: 'discharge11',
                    ref:        'discharge11_input',
                    ref_alt:    'discharge11_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '12',
                    model_name: 'discharge12',
                    ref:        'discharge12_input',
                    ref_alt:    'discharge12_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '13',
                    model_name: 'discharge13',
                    ref:        'discharge13_input',
                    ref_alt:    'discharge13_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '14',
                    model_name: 'discharge14',
                    ref:        'discharge14_input',
                    ref_alt:    'discharge14_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '15',
                    model_name: 'discharge15',
                    ref:        'discharge15_input',
                    ref_alt:    'discharge15_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '16',
                    model_name: 'discharge16',
                    ref:        'discharge16_input',
                    ref_alt:    'discharge16_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '17',
                    model_name: 'discharge17',
                    ref:        'discharge17_input',
                    ref_alt:    'discharge17_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '18',
                    model_name: 'discharge18',
                    ref:        'discharge18_input',
                    ref_alt:    'discharge18_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '19',
                    model_name: 'discharge19',
                    ref:        'discharge19_input',
                    ref_alt:    'discharge19_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '20',
                    model_name: 'discharge20',
                    ref:        'discharge20_input',
                    ref_alt:    'discharge20_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '21',
                    model_name: 'discharge21',
                    ref:        'discharge21_input',
                    ref_alt:    'discharge21_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-1',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       '22',
                    model_name: 'discharge22',
                    ref:        'discharge22_input',
                    ref_alt:    'discharge22_input_alt',
                    required:   false,
                },
            ]
        },
    ],
}

export default FormResources;